import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const app = <React.StrictMode><App /></React.StrictMode>;
// firstElementChild, not hasChildNodes: whitespace inside #root must not trigger hydration.
if (container.firstElementChild) { hydrateRoot(container, app); } else { createRoot(container).render(app); }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
